var heatSink = "https://shopfront-cdn.tekoapis.com/static/d2202e2b35bcb4db.svg";

export { heatSink as default };
